import React from "react"
import useIsSmallScreen from "../hooks/useIsSmallScreen"
import DesktopNavigation from "./DesktopNavigation"
import MobileNavigation from "./MobileNavigation"
import routes from "../components/routes"


const EmployeeLayout = ({ children }) => {

    const isSmallScreen = useIsSmallScreen()

    const menuItems = [
        routes.lessonLogBook,
        routes.groupSubjectLoogBook,
        routes.timetable,
        routes.plans,
    ]

    return isSmallScreen ? (
        <MobileNavigation menuItems={menuItems}>
            {children}
        </MobileNavigation>
    ) : (
        <DesktopNavigation menuItems={menuItems}>
            {children}
        </DesktopNavigation>
    )
}

export default EmployeeLayout